import { Box, Button, Card, CardActions, CardContent, Typography } from "@mui/material";

export function FrameWithSearchBox(props: {
  title: string,
  onSearchClicked: () => void,
  onResetClicked?: () => void,
  children: [JSX.Element, JSX.Element]
}) {

  const [searchBox, content] = props.children;

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
      <Typography variant="h5" sx={{ mb: 1 }}>{props.title}</Typography>
      <Card variant="outlined" sx={{ mb: 1 }}>
        <CardContent>{searchBox}</CardContent>
        <CardActions sx={{ alignSelf: 'stretch', justifyContent: 'center' }}>
          <Button variant="contained" onClick={props.onSearchClicked}>
            Search
          </Button>
          {props.onResetClicked &&
            <Button variant="contained" color="secondary" onClick={props.onResetClicked}>
              Reset
            </Button>
          }
        </CardActions>
      </Card>
      <Box sx={{ flexGrow: 1, height: 0, width: '100%' }}>
        <Card variant="outlined" sx={{ height: '100%', overflow: 'auto' }}>
          <CardContent sx={{ height: '100%' }}>{content}</CardContent>
        </Card>
      </Box>
    </Box>
  );
}

export function Frame(props: {
  title: string,
  children: JSX.Element
}) {

  const content = props.children;

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
      <Typography variant="h5" sx={{ mb: 1 }}>{props.title}</Typography>
      <Box sx={{ flexGrow: 1, height: 0, width: '100%' }}>
        <Card variant="outlined" sx={{ height: '100%', overflow: 'auto' }}>
          <CardContent sx={{ height: '100%' }}>{content}</CardContent>
        </Card>
      </Box>
    </Box>
  );
}